import type {EditorView} from '@codemirror/view'

export function hasNonEmptySelection(view: EditorView): boolean {
  return view.state.selection.ranges.length === 1 && !view.state.selection.main.empty
}
